<template>
  <div>
    <v-btn color="primary" small class="mt-4 mb-5" @click="abrirDialog()">
      <v-icon left>mdi-plus</v-icon>
      Novo
    </v-btn>

    <SysDialogFullScreen
      v-model="dialog"
      :titulo="TITULO_COMPUTED"
      ocultarAcoes
    >
      <template #titulo.text>
        <div>
          <p class="ma-0">Cadastro de similares</p>
          <p class="ma-0 mt-n3 font-12 text-uppercase">
            {{ props.detalhesProduto.idproduto }} - ({{ props.detalhesProduto.idunidade_medida }}) {{ props.detalhesProduto.descricao_produto }}
          </p>
        </div>
      </template>

      <template #titulo-parte-direita>
        <v-btn v-if="similarSelecionado.length > 0" color="primary" @click="salvarSimilares()">Salvar</v-btn>
      </template>

      <div class="d-flex align-center px-2 pt-2">
        <div class="col-6 pa-0 pr-1">
          <v-card>
            <sys-data-table
              v-model="modelEsquerda"
              :headers="HEADERS_ESQUERDA"
              :items="produtos"
              :search="pesquisar"
              :height="altura_janela - 182"
              :item-height="45"
              :loading="loading"
              hide-default-header
              @scroll-items="buscarProdutosSeTiverNoFinalDaRolagem"
            >
              <template #top>
                <div class="d-flex align-center py-2 w-full">
                  <div class="d-flex align-center">
                    <span class="font-18 font-weight-medium ml-1">Lista de Produtos</span>

                    <v-divider class="mx-5" vertical />

                    <Filtros ocultar_filtros_fixos @update:filtros="aplicarFiltros()">
                      <template #prepend>
                        <BlocoFiltrosPrincipais :filtros="filtros" />
                      </template>
                    </Filtros>
                  </div>

                  <v-spacer />

                  <div class="w-350 pr-2">
                    <v-text-field
                      v-model="pesquisar"
                      append-icon="mdi-magnify"
                      label="Pesquisar"
                      single-line
                      hide-details
                      clearable
                      class="ml-3"
                      @change="aplicarFiltros"
                    />
                  </div>
                </div>
              </template>

              <template #item.descricao_produto="{ item }">
                <div class="d-flex align-center pl-1">
                  <DetalhesProduto
                    class="ml-n2"
                    :produto="{
                      id_grupo: props.detalhesProduto.id_grupo,
                      id_filial: (Number(props.detalhesProduto.id_filial) === 9999) ? 9999 : item.id_filial,
                      id_produto: String(item.idproduto),
                      produto_eh_combinacao: props.detalhesProduto.produto_eh_combinacao
                    }"
                  />

                  <span class="d-block" v-text="item.descricao_produto" />
                </div>
              </template>

              <template #item.unidade_venda="{ item }">
                <div class="d-flex pl-1">
                  <span class="pt-2" v-text="item.unidade_venda" />

                  <v-spacer />

                  <v-btn icon @click="selecinarProduto(item, 2)">
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-btn>
                </div>
              </template>
            </sys-data-table>
          </v-card>
        </div>

        <div class="col-6 pa-0 pl-1">
          <v-card>
            <sys-data-table
              v-model="modelDireita"
              :headers="HEADERS_DIREITA"
              :items="similarSelecionado"
              :height="altura_janela - 182"
              :item-height="45"
              hide-default-header
              :item-class="itemClass"
            >
              <template #top>
                <div class="py-5">
                  <span class="font-18 font-weight-medium ml-1">Produtos selecionados</span>
                </div>
              </template>

              <template #item.descricao_produto="{ item }">
                <div class="d-flex align-center pl-1">
                  <v-btn icon @click="selecinarProduto(item, 1)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>

                  <DetalhesProduto
                    class="ml-n2"
                    :produto="{
                      id_grupo: props.detalhesProduto.id_grupo,
                      id_filial: (Number(props.detalhesProduto.id_filial) === 9999) ? 9999 : item.id_filial,
                      id_produto: String(item.idproduto),
                      produto_eh_combinacao: props.detalhesProduto.produto_eh_combinacao
                    }"
                  />

                  <span class="d-block" v-text="item.descricao_produto" />

                  <v-spacer />
                </div>
              </template>

              <template #item.agrupar_estoque="{ item }">
                <v-checkbox
                  :disabled="item.idunidade_medida !== props.detalhesProduto.idunidade_medida"
                  v-model="item.agrupar_estoque"
                  label="Agrupar estoque?"
                  hide-details
                  dense
                />
              </template>

              <template #footer.prepend>
                <div class="d-flex align-center">
                  <div class="bg-red quadrado-15 mx-1">&nbsp;</div>
                  <span class="pt-1 font-12">
                    Não é possível agrupar estoque, pois a unidade de venda é diferente
                  </span>
                </div>
              </template>
            </sys-data-table>
          </v-card>
        </div>
      </div>
    </SysDialogFullScreen>
  </div>
</template>

<script setup>
import { useResize } from "@/helpers/Resize";
import { computed, ref, watch } from 'vue';
import SysDialogFullScreen from '@/components/padraoDeLayout/SysDialogFullScreen.vue';
import Filtros from "@/components/Diagnostico/utils/Filtros";
import Api from '@/api/api';
import store from "@/store";
import {logout} from "@/helpers";
import BlocoFiltrosPrincipais from "@/components/compra/ProdutosGerais/Filtros/BlocoFiltrosPrincipais.vue";
import DetalhesProduto from "@/components/produto/detalhes/Index";

const emit = defineEmits(['atualizar-similares']);

const props = defineProps({
  detalhesProduto: {
    type: Object
  }
});

const { altura_janela } = useResize();
const HEADERS_ESQUERDA = computed(() => [
  { text: 'Descrição do Produto', value: 'descricao_produto' },
  { text: 'Unidade Venda', value: 'unidade_venda' },
]);
const HEADERS_DIREITA = computed(() => [
  { text: 'Descrição do Produto', value: 'descricao_produto' },
  { text: 'Unidade Venda', value: 'unidade_venda' },
  { text: 'Agrupar Estoque', value: 'agrupar_estoque' },
]);
const quantidade_produtos_por_pagina = 500;
const dialog = ref(false);
const modelEsquerda = ref([]);
const modelDireita = ref([]);
const produtos = ref([]);
const similarSelecionado = ref([]);
const FORNECEDOR_COMPRAS = computed(() => store.getters["fornecedor/getFornecedor"]);
const GRUPO_COMPRAS = computed(() => store.getters['usuario/getGrupoCompras']);
const TITULO_COMPUTED = computed(() => 'Cadastro de similares para o produto: ' + props.detalhesProduto.descricao_produto);
const pesquisar = ref('');
const loading = ref(false);
const PAGINA_ATUAL_PRODUTOS = computed(() => Math.trunc(produtos.value.length / quantidade_produtos_por_pagina));
const todos_produtos_carregados = ref(false);
const filtros = ref({
  grupos: [],
  filiais: [],
  segmentos: [],
  secoes: [],
  categorias: [],
  linhas: [],
  compradores: [],
  fornecedores: [],
  marcas: [],
});
let timerScrollDataTable;

watch(modelEsquerda, (valor) => {
  if (modelEsquerda.value.length == 0) return;

  valor.forEach(el => {
    let indexParaRemover = produtos.value.findIndex(objeto => objeto.idproduto === el.idproduto);

    if (indexParaRemover !== -1) {
      produtos.value.splice(indexParaRemover, 1)[0];
      similarSelecionado.value.unshift(el);
    }
  });

  modelEsquerda.value = [];
});

watch(modelDireita, (valor) => {
  if (modelDireita.value.length == 0) return;

  valor.forEach(el => {
    let indexParaRemover = similarSelecionado.value.findIndex(objeto => objeto.idproduto === el.idproduto);

    if (indexParaRemover !== -1) {
      similarSelecionado.value.splice(indexParaRemover, 1)[0];
      produtos.value.unshift(el);
    }
  });

  modelDireita.value = [];
});

function itemClass (item) {
  return {
    'text-red': item.idunidade_medida !== props.detalhesProduto.idunidade_medida
  }
}

function selecinarProduto(item, v) {
  if (v === 2) {
    modelEsquerda.value = [item];
  } else {
    modelDireita.value = [item];
  }
}

function abrirDialog() {
  dialog.value = true;
  buscarProdutosSobDemanda();
}

function salvarSimilares() {
  if (similarSelecionado.value.length === 0) {
    return;
  }

  const params = {
    grupo: props.detalhesProduto.id_grupo,
    fornecedor: FORNECEDOR_COMPRAS.value.id,
    pai: props.detalhesProduto.idproduto,
    filho: similarSelecionado.value
  };

  Api
    .post('add_similares', params)
    .then(() => {
      similarSelecionado.value = [];
      dialog.value = false;
      emit('atualizar-similares');
    })
    .catch(logout);
}

function buscarProdutosSeTiverNoFinalDaRolagem({scrollHeight, scrollTop, offsetHeight}) {
  if ((scrollTop + offsetHeight + 50) < scrollHeight || !(produtos.value.length > 0)) return;
  clearTimeout(timerScrollDataTable);
  timerScrollDataTable = setTimeout(() => buscarProdutosSobDemanda(), 500)
}

function buscarProdutosSobDemanda (pesquisaProduto = "") {
  if (todos_produtos_carregados.value) return;

  loading.value = true;

  const config = {
    params: {
      quantidade_produtos_por_pagina,
      pagina: PAGINA_ATUAL_PRODUTOS.value + 1,
      grupo: GRUPO_COMPRAS.value,
      pesquisaProduto,
      incluir_produtos_combinados: true,
      ...filtros.value
    }
  }
  Api.post('get_produtos_sob_demanda', config.params)
    .then((response) => {
      loading.value = false;
      produtos.value.push(...response.data.produtos);
      todos_produtos_carregados.value = response.data.produtos.length !== quantidade_produtos_por_pagina;
    })
    .catch(logout);
}

function aplicarFiltros() {
  loading.value = true;
  produtos.value = [];
  todos_produtos_carregados.value = false;
  buscarProdutosSobDemanda(pesquisar.value);
}
</script>
